import { Chip, ColorsV2, IconNames, useThemeColors } from '@electricjs/arc';
import { DeviceIssueStatus } from '@/components/Assets/AssetDetails/DeviceSecurityPanel/DeviceSecurityPanel';

export const DeviceIssueStatusChip = ({
  status,
  text,
}: {
  status: (typeof DeviceIssueStatus)[keyof typeof DeviceIssueStatus];
  text?: string;
}) => {
  // Unknown
  const [unknownBackgroundColor, unknownTextColor] = useThemeColors([
    ColorsV2.GRAY_LIGHTER,
    ColorsV2.GRAY_DARKEST,
  ]);

  // Issue
  const [issueBackgroundColor, issueTextColor] = useThemeColors([
    ColorsV2.WARNING_LIGHTEST,
    ColorsV2.WARNING_DARKEST,
  ]);

  // Enabled and Good
  const [successBackgroundColor, successTextColor] = useThemeColors([
    ColorsV2.SUCCESS_LIGHTEST,
    ColorsV2.SUCCESS_DARKEST,
  ]);

  // Failed
  const [errorBackgroundColor, errorTextColor] = useThemeColors([
    ColorsV2.ERROR_LIGHTEST,
    ColorsV2.ERROR_DARKEST,
  ]);

  const colorMap = {
    [DeviceIssueStatus.Unknown]: {
      icon: 'question-circle',
      backgroundColor: unknownBackgroundColor,
      textColor: unknownTextColor,
    },
    [DeviceIssueStatus.Enabled]: {
      icon: 'check-circle',
      backgroundColor: successBackgroundColor,
      textColor: successTextColor,
    },
    [DeviceIssueStatus.Failed]: {
      icon: 'alert-circle',
      backgroundColor: errorBackgroundColor,
      textColor: errorTextColor,
    },
    [DeviceIssueStatus.Issue]: {
      icon: 'alert-triangle',
      backgroundColor: issueBackgroundColor,
      textColor: issueTextColor,
    },
    [DeviceIssueStatus.Good]: {
      icon: 'check-circle',
      backgroundColor: successBackgroundColor,
      textColor: successTextColor,
    },
  };

  return (
    <Chip
      id="info-unknown-chip"
      icon={colorMap[status].icon as IconNames}
      variant="small"
      backgroundColor={colorMap[status].backgroundColor}
      textColor={colorMap[status].textColor}>
      {text ?? status}
    </Chip>
  );
};
